module.exports = __webpack_public_path__ + "static/WhatsApp-9ccbdf36f3e7e09d8fdc0a96af1a5baa.svg";